<template>
    <div class="more">
        <div class="header">
            <div class="header-left" @click="back">
                 <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
                <p>{{townStreet? townStreet:'虎门镇'}}</p>
            </div>
            <div class="header-right" @click="home">
               <span class="iconfont iconhome"></span>
            </div>
        </div>
        <!-- 轮播图 -->
       <div class="swiper">
        <swiper :options="swiperOption">
            <swiper-slide v-for="(item,index) in BannerList" :key="index">
                <img :src="item.Url" alt="">
            </swiper-slide>
         <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
     </div>
       <!-- 服务项目 -->
      <div class="service">
          <p>服务项目</p>
         <div class="serviceItem" v-for="(item,index) in MainButtonList" :key="index" @click="toServiceItem(item.Link,item.LinkType)">
             <img :src="item.Url" alt="">
         </div>

      </div>


    </div>
</template>

<script>
import {mapState} from 'vuex'
import { Toast } from 'vant'
export default {
    data () {
        return {
          swiperOption:{
            pagination: {
            el: '.swiper-pagination'
            },
            loop: true,
            autoplay: 5000
          },
          BannerList: [],
          MainButtonList: []
        }
    },
    computed: {
      ...mapState(['townStreet'])
    },
    created () {
        this.$axios.get('/api/DjOrder/GetIndexInfo',{
          params: {
            ContentType:"更多页"
          }
       }).then(res => {
           let data = res.data
            // console.log(data)
           this.BannerList = data.BannerList

           if (process.env.NODE_ENV === "development"){
             this.MainButtonList = data.MainButtonList.map((i) => {
                i.Url = 'http://www.lungchuenjz.cn' + i.Url
                return i
             })
           }else{
             this.MainButtonList = data.MainButtonList
           }
           
           // console.log(this.MainButtonList)
       })
    },
    methods: {
        back () {
            this.$router.back()
        },
        home () {
            this.$router.push('/')
        },
        toServiceItem(Link,LinkType){
          if(LinkType == 'NotLink'){
            console.log('不跳转')
            return
          }else if(LinkType == 'ToUrl'){
            this.$router.push(Link)
          }else if(LinkType == 'ShowTips'){
            Toast(Link);
          }
        }
    }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .header
    width: 100%
    display: flex
    justify-content: space-between
    width: 100%
    height: 40px
    align-items: center
    font-weight: bold
    border-bottom: 1px solid #eee
    .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
    .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
  .swiper
    width: 100%
    & img
      width: 100%
  .service
    width: 100%
    margin-top: 5px
    &>p
      font-size: 18px
      margin-left: 5px
      margin-bottom: 5px
    .serviceItem
      width: 96%
      margin: auto
      border-radius: 15px
      margin-bottom: 5px
      &>img
        width: 100%
        border-radius: 15px
        margin: 1px


</style>



// WEBPACK FOOTER //
// src/pages/More/More.vue